import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import { formatFt } from '@/libs/currency'
import axios from 'axios'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || `${window.location.origin}/api/`
axios.defaults.baseURL = apiBaseUrl

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false
Vue.prototype.$formatFt = formatFt
Vue.filter('ft', formatFt)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
